"use strict";
/*
 * generated by scripts/build/buildVersion.js
 */
Object.defineProperty(exports, "__esModule", { value: true });
var VERSION = '1.3.11';
exports.default = VERSION;
//# sourceMappingURL=Version.js.map